var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('figure',{staticClass:"image",class:_vm.dimension},[_c('img',{class:{ 'is-rounded': _vm.rounded },attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }